import React, { useEffect, useRef, useState } from 'react'

import styles from './styles.module.scss'

import { ReactComponent as EnvelopeIcon } from '../../../assets/icons/udelivered-convert.svg'
import { ReactComponent as HeadphonesIcon } from './icons/headphones.svg'
import { ReactComponent as RefIcon } from './icons/refIcon.svg'

import UserProfile from '../../UserProfile/UserProfile'
import { useDispatch, useSelector } from 'react-redux'
import { getLocalStorageItem } from '../../../helpers/helpers'

import Support from '../../Support/Support'
import useBillingActive from '../../../hooks/useBillingActive'
import Store from './Store/Store'
import cn from 'classnames'
import { Button, buttonClasses, Popover, popoverClasses } from '@mui/material'
import Operator from '../../Operator/Operator'
import { setIsSupportOpenedAction, setSupportMessageTextAction } from '../../../redux/support/support.action'
import ReferralModal from './Referral/ReferalModal/ReferralModal'
import useClickOutside from '../../../hooks/useClickOutside'
import { isMobileDevice } from '../../../helpers/mobileDevice.helper'

const Controls = ({ isAdmin }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isReferralModalOpen, setIsReferralModalOpen] = useState(false)

  const { is_opened } = useSelector(({ support }) => support)
  const referralData = useSelector(({ billing }) => billing.referralData)

  const modalRef = useClickOutside(() => setIsReferralModalOpen(false))

  const confirmRef = useRef(null)
  const referralSysRef = useRef(null)
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const dispatch = useDispatch()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleOpenClick = (ref) => {
    if (ref.current) {
      ref.current.click() // Программный клик на кнопку
    }
  }

  const handleOpenCloseModal = (e) => {
    e.stopPropagation()
    setIsReferralModalOpen(!isReferralModalOpen)
  }

  const handleClose = () => {
    setAnchorEl(null)
    dispatch(setIsSupportOpenedAction(false))
    dispatch(setSupportMessageTextAction(''))
  }

  const { isSocketConnected } = useSelector(({ ui }) => ui)
  const { undelivered_count, loading, work } = useSelector(({ support }) => support)

  const isBillingActive = useBillingActive()

  const user = getLocalStorageItem('user')

  useEffect(() => {
    if (is_opened) {
      handleOpenClick(confirmRef)
    }
  }, [is_opened])

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const referralLinkQuery = query.get('referral')
    const referralLink = localStorage.getItem('referral')
    if (referralLink && referralLinkQuery && referralLinkQuery === referralLink) {
      handleOpenClick(referralSysRef)
    }
  }, [])

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        setIsReferralModalOpen(false)
      }
    }

    window.addEventListener('keydown', handleEsc)

    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      {isBillingActive &&
        !isAdmin &&
        (referralData ? (
          <>
            <Button
              aria-describedby={id}
              variant='contained'
              onClick={handleOpenCloseModal}
              ref={referralSysRef}
              disabled={user?.isAdmin}
              sx={{
                width: '60px',
                height: '60px',
                minWidth: '60px',
                minHeight: '60px',
                backgroundColor: isReferralModalOpen ? '#06251e' : 'transparent',
                boxShadow: 'none',
                padding: 0,
                color: '#222',
                [`&:hover`]: {
                  backgroundColor: '#06251e',
                },
                [`&.${buttonClasses.disabled}`]: {
                  filter: 'grayscale(1)',
                  backgroundColor: 'transparent',
                  cursor: 'not-allowed',
                },
              }}
            >
              <Operator value={'Referral'} isActive={isReferralModalOpen}>
                <RefIcon />
              </Operator>
            </Button>
            {/*<Referral ref={referralSysRef} handleClick={handleOpenCloseModal} />*/}
            {isReferralModalOpen && <ReferralModal promoCode={localStorage.getItem('referral')} ref={modalRef} />}
          </>
        ) : (
          <Store />
        ))}

      <Button
        id='tour-step-5'
        aria-describedby={id}
        variant='contained'
        onClick={handleClick}
        ref={confirmRef}
        disabled={!isSocketConnected || user?.isAdmin}
        sx={{
          width: '60px',
          height: '60px',
          minWidth: '60px',
          minHeight: '60px',
          backgroundColor: open ? '#06251e' : 'transparent',
          boxShadow: 'none',
          padding: 0,
          color: '#222',
          [`&:hover`]: {
            backgroundColor: '#06251e',
          },
          [`&.${buttonClasses.disabled}`]: {
            filter: 'grayscale(1)',
            backgroundColor: 'transparent',
            cursor: 'not-allowed',
          },
        }}
      >
        <Operator isActive={open}>
          {undelivered_count && loading && work ? (
            <EnvelopeIcon height={20} width={28} className={cn('envelope', styles.envelope)} />
          ) : (
            <HeadphonesIcon />
          )}
        </Operator>
      </Button>

      {/*<NotificationStatus isActive={true} />*/}

      <div className={styles.user_profile_wrapper}>
        <UserProfile isAdmin={isAdmin} buttonId={!isMobileDevice() ? 'tour-step-6' : undefined} />
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transition='true'
        sx={{
          [`.${popoverClasses.paper}`]: {
            marginTop: '20px',
            marginLeft: '0px',
            width: '100%',
            maxWidth: '300px',
            boxShadow: '0 4px 15px 0 rgba(0, 0, 0, 0.1)',
            zIndex: 100,
            '@media (orientation: landscape) and (max-width: 1199.95px) and (max-height: 550px)': {
              minHeight: '100dvh',
            },
            '@media (min-width: 375px)': {
              maxWidth: '340px',
            },
            '@media (min-width: 468px)': {
              maxWidth: '406px',
            },
            '@media (min-width: 1200px)': {
              marginTop: '40px',
              maxHeight: '540px',
              minHeight: 'auto',
            },
          },
        }}
      >
        <Support />
      </Popover>
    </div>
  )
}

export default Controls
